/* eslint-disable react/prop-types */
import { Checkbox, FormControlLabel } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import DayRow from "./DayRow";
import DaySelectors from "./DaySelectors";
import Meal from "./Meal";
import HourPerDay from "./HourPerDay";
import HourPerWeek from "./HourPerWeek";
import { days } from "./utils";
import { Validator } from "./validator2";
import { isEmptyObject } from "utils";

const ValidatorInstance = Validator.instance();

export default function WorkingHours(props) {
  const { initialValue } = props;
  const [selectedDay, setSelectedDay] = useState({});
  const [first, setFirst] = useState(-1);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isEmptyObject(initialValue)) {
      setChecked(initialValue?.workingHoursEnabled);
    }
  }, [initialValue]);

  const { unregister, control, setValue, errors, watch, getValues } =
    useFormContext();

  const formData = watch();

  React.useMemo(() => ValidatorInstance.validate(formData), [formData]);

  useEffect(() => {
    ValidatorInstance.validate(getValues());
  });

  const handleChange = (selections, isInitial) => {
    // console.log("Selections", selections);

    const selects = [];
    for (let d of days) {
      if (selections[d.index] == false) {
        unregister(d.name);
      } else {
        selects.push(d);
      }
    }

    setFirst(selects.length > 0 ? selects[0].index : -1);
    if (selects.length == 0) {
      setChecked(false);
      setValue("workingHoursEnabled", false);
    } else {
      if (isInitial) {
        setChecked(initialValue.workingHoursEnabled);
        setValue("workingHoursEnabled", initialValue.workingHoursEnabled);
      } else {
        setChecked(true);
        setValue("workingHoursEnabled", true);
      }
    }
    setSelectedDay(selections);
  };

  const enableWorkerHours = (e) => {
    setChecked(e.target.checked);
    // console.log(e.target.checked);
    if (e.target.checked === true) {
      const selectedDaysStatus = Object.values(selectedDay);
      const tickedDay = [...selectedDaysStatus.keys()].filter(
        (i) => selectedDaysStatus[i]
      );

      if (tickedDay.length >= 1) {
        selectedDay[tickedDay[0]] = true;
        setFirst(tickedDay[0]);
      } else {
        selectedDay[1] = true;
        setFirst(1);
      }
    }
  };

  return (
    <>
      <FormControlLabel
        control={
          <Controller
            name="workingHoursEnabled"
            control={control}
            defaultValue={checked}
            render={(props) => (
              <Checkbox
                {...props}
                checked={props.value}
                onChange={(e) => {
                  props.onChange(e.target.checked);
                  enableWorkerHours(e);
                }}
                color="primary"
                inputRef={props.ref}
              />
            )}
          />
        }
        label="Enable Working Hours"
      />

      <DaySelectors
        disabled={!checked}
        onSelectionChange={handleChange}
        initialValue={initialValue}
        errors={errors}
      />
      <div style={{ marginTop: 16 }} />
      {days.map((d, i) =>
        selectedDay[i] ? (
          <DayRow
            disabled={!checked}
            day={d}
            key={i}
            isFirst={first == d.index}
            index={d.index}
            errors={errors}
          />
        ) : (
          ""
        )
      )}
      <Meal scheduleTick={checked} />
     
      <HourPerWeek   scheduleTick={checked}/>
      <HourPerDay scheduleTick={checked} />
      
    </>
  );
}
